import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative h-[420px] md:h-[600px] w-full overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=dark%20cinema%20theater%20interior%20with%20red%20velvet%20curtains%20and%20warm%20golden%20stage%20lights%2C%20empty%20seats%2C%20dramatic%20atmosphere%2C%20cinematic%20photography%2C%20luxurious%20movie%20theater%2C%20soft%20spotlight%20glow&width=1800&height=900&seq=hero-cinema-01&orientation=landscape')`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-background-950/70"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 text-center mb-4 md:mb-6">
          发现你的<span className="text-primary-400">下一部</span>最爱电影
        </h1>
        <p className="text-sm md:text-lg text-background-200/90 text-center max-w-2xl mb-8 md:mb-10 leading-relaxed">
          小草影院汇集院线大片、最新上映电影及动作片、喜剧电影等分类大全。每日更新片库，高清在线观看各类影片，快速找到你想看的电影。
        </p>

        <div className="flex flex-col sm:flex-row items-center gap-3 w-full max-w-lg">
          <div className="relative w-full">
            <input
              type="text"
              placeholder="搜索你喜欢的电影..."
              className="w-full text-sm px-5 py-3.5 rounded-full bg-background-50/95 backdrop-blur-sm border border-background-200/50 focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-300/30 text-foreground-700 placeholder-foreground-400 shadow-lg"
            />
            <button className="absolute right-2 top-1/2 -translate-y-1/2 bg-primary-500 hover:bg-primary-600 text-background-50 px-5 py-2 rounded-full text-sm font-medium transition-colors cursor-pointer whitespace-nowrap" aria-label="搜索">
              <i className="ri-search-line mr-1"></i>
              搜索
            </button>
          </div>
        </div>

        <div className="flex items-center gap-2 mt-6 md:mt-8">
          <span className="text-xs text-background-300">热门搜索：</span>
          <Link to="/category/action" className="text-xs text-background-200 hover:text-primary-300 transition-colors px-2 py-1 rounded-full bg-background-50/10 whitespace-nowrap">
            动作片
          </Link>
          <Link to="/category/comedy" className="text-xs text-background-200 hover:text-primary-300 transition-colors px-2 py-1 rounded-full bg-background-50/10 whitespace-nowrap">
            喜剧电影
          </Link>
          <Link to="/category/scifi" className="text-xs text-background-200 hover:text-primary-300 transition-colors px-2 py-1 rounded-full bg-background-50/10 whitespace-nowrap">
            科幻大片
          </Link>
          <Link to="/category/romance" className="text-xs text-background-200 hover:text-primary-300 transition-colors px-2 py-1 rounded-full bg-background-50/10 whitespace-nowrap">
            爱情电影
          </Link>
        </div>
      </div>
    </section>
  );
}